import React from "react";
import { Badge, Card, Row, Col } from "antd";
import { ClockCircleOutlined, MessageOutlined } from "@ant-design/icons";
import VideoTag from "@Components/activity/VideoTag";
import moment from "moment";
import useActivityItem from "@Components/activity/hooks/useActivityItem";
import { IActivityDetails } from "@Models/IActivityDetails";
import { getActivityIconBackground } from "@Images/images-utils";
import { getActivityLabel, getDuration } from "@Utils";

import "@Styles/main.scss";

interface IProps {
    activity: IActivityDetails;
    onClick?: (activityInstanceId: string) => void;
}

const ActivityItem: React.FC<IProps> = (props: IProps) => {
    const {
        activityComments,
        activityInstanceId,
        categoryName,
        creationDate,
        duration,
        mediaStatus,
        thumbnailUrl,
        userFullName,
        userId,
    } = props.activity;

    const { handleActivitySelect } = useActivityItem({ userId });

    const handleClick = () => {
        handleActivitySelect(activityInstanceId);
        props?.onClick?.(activityInstanceId);
    };

    const coverContent = thumbnailUrl ? (
        <div
            className="activity-item-background"
            style={{
                backgroundImage: `url('${thumbnailUrl}')`,
                backgroundSize: "cover",
            }}
        />
    ) : (
        <div
            className="activity-item-background"
            style={{
                backgroundImage: `url(${getActivityIconBackground(categoryName)})`,
                backgroundSize: "120px 120px",
            }}
        />
    );

    const actions = [
        <div title={`Duration: ${getDuration(duration)}`} className="activity-action-item">
            <ClockCircleOutlined
                style={{
                    opacity: 0.3,
                }}
            />
            {getDuration(duration)}
        </div>,
        <span>
            <VideoTag mediaStatus={mediaStatus} margin={5} minimal />
        </span>,
        <span>
            {activityComments.length > 0 && (
                <div className="activity-action-item">
                    <MessageOutlined key="comments" style={{ opacity: 0.3 }} />
                    <span>{activityComments.length}</span>
                </div>
            )}
        </span>,
    ];

    return (
        <div className="activity-item" onClick={handleClick}>
            <div className="activity-item-cover">
                {coverContent}
                <div className="activity-item-cover-gradient" />
            </div>
            <Card className="activity-item-card" hoverable={false}>
                <Row>
                    <Col span={18}>
                        <Card.Meta
                            style={{ borderRadius: "10px" }}
                            title={getActivityLabel(props.activity)}
                            description={
                                <div>
                                    <div>{userFullName}</div>
                                    <div>{moment(creationDate).format("LLLL")}</div>
                                </div>
                            }
                        />
                    </Col>
                    <Col span={6}>{actions}</Col>
                </Row>
            </Card>
        </div>
    );
};

export default ActivityItem;
